import React from 'react'
import Quiz from './components/Quiz'
import "./App.css"
function App() {
  return (
    <>
    <h1>Hello Gautam How Are You </h1>
      <Quiz/>
    </>
  )
}
export default App